export const PRODUCT_DETAIL_PAGE_WITH_PRODUCT_PATH_REGEX = ':productDetailUrlKeyword([^/]*)-:pdpPath(p|pm)-:productId([a-zA-Z0-9-]*)'
export const PRODUCT_COMMENT_PAGE_WITH_PRODUCT_PATH_REGEX = ':productDetailUrlKeyword([^/]*)-:pdpPath(p|pm)-:productId([a-zA-Z0-9-]*)-:reviewPath(yorumlari)'
export const PRODUCT_QNA_PAGE_WITH_PRODUCT_PATH_REGEX = ':productDetailUrlKeyword([^/]*)-:pdpPath(p|pm)-:productId([a-zA-Z0-9-]*)-:qnaPath(saticiya-sor)'
export const CATEGORY_PAGE_ROUTE_PATH_REGEX = '/:brandIds([^/]+)?/:categoryUrlKeyword([^/]+)-:plpPath(c|xc)-:categoryId(\\d+):others(-.*)?'
export const COLLECTION_PAGE_ROUTE_PATH_REGEX = ':collectionPageKeyword([^/]*)-x-s([1-8]):collectionPageQueryParams([^/]*)'
const PLATFORMS = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
}
const PAGES = {
  HOME_PAGE: 'HOME_PAGE',
  HOME_PAGE_V2: 'HOME_PAGE_V2',
  CATEGORY_PAGE: 'CATEGORY_PAGE',
  BRAND_CATEGORY_PAGE: 'BRAND_CATEGORY_PAGE',
  SEARCH_PAGE: 'SEARCH_PAGE',
  COLLECTION_PAGE: 'COLLECTION_PAGE',
  HURLY_CATEGORY_PAGE: 'HURLY_CATEGORY_PAGE',
  CAMPAIGN_PAGE: 'CAMPAIGN_PAGE',
  TAG_PAGE: 'TAG_PAGE',
  DYNAMIC_PAGE: 'DYNAMIC_PAGE',
  DYNAMIC_VIEW_PAGE: 'DYNAMIC_VIEW_PAGE',
  STATIC_PAGE: 'STATIC_PAGE',
  STATIC_PAGE_PREVIEW: 'STATIC_PAGE_PREVIEW',
  PRODUCT_QNA_PAGE_WITH_PRODUCT_SKU: 'PRODUCT_QNA_PAGE_WITH_PRODUCT_SKU',
  PRODUCT_QNA_PAGE_WITH_PRODUCT_ID: 'PRODUCT_QNA_PAGE_WITH_PRODUCT_ID',
  PRODUCT_COMMENT_PAGE_WITH_PRODUCT_SKU: 'PRODUCT_COMMENT_PAGE_WITH_PRODUCT_SKU',
  PRODUCT_COMMENT_PAGE_WITH_PRODUCT_ID: 'PRODUCT_COMMENT_PAGE_WITH_PRODUCT_ID',
  PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU: 'PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU',
  PRODUCT_DETAIL_PAGE_WITH_PRODUCT_ID: 'PRODUCT_DETAIL_PAGE_WITH_PRODUCT_ID',
  BRAND_PAGE: 'BRAND_PAGE',
  AUTHORS_PAGE: 'AUTHORS_PAGE',
  TEST_PAGE: 'TEST_PAGE',
  MERCHANT_PAGE: 'MERCHANT_PAGE',
  SHOPPING_ASSISTANT: 'SHOPPING_ASSISTANT',
  BRANDS_PAGE: 'BRANDS_PAGE',
  MERCHANTS_PAGE: 'MERCHANTS_PAGE',
}
const ROUTE_PATHS = {
  [PLATFORMS.MOBILE]: {
    [PAGES.HOME_PAGE]: '/',
    [PAGES.HOME_PAGE_V2]: '/v2',
    [PAGES.SHOPPING_ASSISTANT]: '/shopping-assistant',
    [PAGES.CAMPAIGN_PAGE]: '/kampanyalar',
    [PAGES.BRANDS_PAGE]: '/markalar/:letter?',
    [PAGES.DYNAMIC_PAGE]: '/dp/:dynamicId',
    [PAGES.DYNAMIC_VIEW_PAGE]: '/dv/:dynamicViewId',
    [PAGES.STATIC_PAGE]: '/staticpage/:staticPageId',
    [PAGES.STATIC_PAGE_PREVIEW]: '/staticpage/preview/:staticPageKey',
    [PAGES.AUTHORS_PAGE]: '/yazarlar/:letter?',
    [PAGES.TAG_PAGE]: '/kampanyalar/:tagId',
    [PAGES.MERCHANTS_PAGE]: '/magaza',
    [PAGES.PRODUCT_QNA_PAGE_WITH_PRODUCT_SKU]: `/${PRODUCT_QNA_PAGE_WITH_PRODUCT_PATH_REGEX}`,
    [PAGES.PRODUCT_QNA_PAGE_WITH_PRODUCT_ID]: `/${PRODUCT_QNA_PAGE_WITH_PRODUCT_PATH_REGEX}`,
    [PAGES.PRODUCT_COMMENT_PAGE_WITH_PRODUCT_SKU]: `/${PRODUCT_COMMENT_PAGE_WITH_PRODUCT_PATH_REGEX}`,
    [PAGES.PRODUCT_COMMENT_PAGE_WITH_PRODUCT_ID]: `/${PRODUCT_COMMENT_PAGE_WITH_PRODUCT_PATH_REGEX}`,
    [PAGES.PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU]: `/${PRODUCT_DETAIL_PAGE_WITH_PRODUCT_PATH_REGEX}`,
    [PAGES.PRODUCT_DETAIL_PAGE_WITH_PRODUCT_ID]: `/${PRODUCT_DETAIL_PAGE_WITH_PRODUCT_PATH_REGEX}`,
    [PAGES.CATEGORY_PAGE]: CATEGORY_PAGE_ROUTE_PATH_REGEX,
    [PAGES.HURLY_CATEGORY_PAGE]: CATEGORY_PAGE_ROUTE_PATH_REGEX,
    [PAGES.SEARCH_PAGE]: '/ara',
    [PAGES.COLLECTION_PAGE]: `/${COLLECTION_PAGE_ROUTE_PATH_REGEX}`,
    [PAGES.BRAND_CATEGORY_PAGE]: CATEGORY_PAGE_ROUTE_PATH_REGEX,
    [PAGES.BRAND_PAGE]: '/:brandId',
    [PAGES.TEST_PAGE]: '/test',
    [PAGES.MERCHANT_PAGE]: '/magaza/:postfix',
  },
  [PLATFORMS.DESKTOP]: {
    [PAGES.HOME_PAGE]: '/',
    [PAGES.CAMPAIGN_PAGE]: '/kampanyalar',
    [PAGES.BRANDS_PAGE]: '/markalar/:letter?',
    [PAGES.DYNAMIC_PAGE]: '/dp/:dynamicId',
    [PAGES.DYNAMIC_VIEW_PAGE]: '/dv/:dynamicViewId',
    [PAGES.STATIC_PAGE]: '/staticpage/:staticPageId',
    [PAGES.STATIC_PAGE_PREVIEW]: '/staticpage/preview/:staticPageKey',
    [PAGES.AUTHORS_PAGE]: '/yazarlar/:letter?',
    [PAGES.TAG_PAGE]: '/kampanyalar/:tagId',
    [PAGES.MERCHANTS_PAGE]: '/magaza',
    [PAGES.PRODUCT_QNA_PAGE_WITH_PRODUCT_SKU]: `/${PRODUCT_QNA_PAGE_WITH_PRODUCT_PATH_REGEX}`,
    [PAGES.PRODUCT_QNA_PAGE_WITH_PRODUCT_ID]: `/${PRODUCT_QNA_PAGE_WITH_PRODUCT_PATH_REGEX}`,
    [PAGES.PRODUCT_COMMENT_PAGE_WITH_PRODUCT_SKU]: `/${PRODUCT_COMMENT_PAGE_WITH_PRODUCT_PATH_REGEX}`,
    [PAGES.PRODUCT_COMMENT_PAGE_WITH_PRODUCT_ID]: `/${PRODUCT_COMMENT_PAGE_WITH_PRODUCT_PATH_REGEX}`,
    [PAGES.PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU]: `/${PRODUCT_DETAIL_PAGE_WITH_PRODUCT_PATH_REGEX}`,
    [PAGES.PRODUCT_DETAIL_PAGE_WITH_PRODUCT_ID]: `/${PRODUCT_DETAIL_PAGE_WITH_PRODUCT_PATH_REGEX}`,
    [PAGES.CATEGORY_PAGE]: CATEGORY_PAGE_ROUTE_PATH_REGEX,
    [PAGES.HURLY_CATEGORY_PAGE]: CATEGORY_PAGE_ROUTE_PATH_REGEX,
    [PAGES.SEARCH_PAGE]: '/ara',
    [PAGES.BRAND_CATEGORY_PAGE]: CATEGORY_PAGE_ROUTE_PATH_REGEX,
    [PAGES.COLLECTION_PAGE]: `/${COLLECTION_PAGE_ROUTE_PATH_REGEX}`,
    [PAGES.BRAND_PAGE]: '/:brandId',
    [PAGES.MERCHANT_PAGE]: '/magaza/:postfix',
  },
}
const ROUTE_CONFIGS = {
  [PLATFORMS.MOBILE]: {
    [ROUTE_PATHS[PLATFORMS.MOBILE].HOME_PAGE]: {
      routeName: PAGES.HOME_PAGE,
      pageType: 'home',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.HOME_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.HOME_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].HOME_PAGE_V2]: {
      routeName: PAGES.HOME_PAGE_V2,
      pageType: 'home',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.HOME_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.HOME_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].SHOPPING_ASSISTANT]: {
      routeName: PAGES.SHOPPING_ASSISTANT,
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      layout: 'empty',
      onEnterActionName: `ENTER_${PAGES.SHOPPING_ASSISTANT}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.SHOPPING_ASSISTANT}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].CATEGORY_PAGE]: {
      routeName: PAGES.CATEGORY_PAGE,
      pageType: 'category',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.CATEGORY_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.CATEGORY_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].BRAND_CATEGORY_PAGE]: {
      routeName: PAGES.BRAND_CATEGORY_PAGE,
      pageType: 'category',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.BRAND_CATEGORY_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.BRAND_CATEGORY_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].HURLY_CATEGORY_PAGE]: {
      routeName: PAGES.HURLY_CATEGORY_PAGE,
      pageType: 'category',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.HURLY_CATEGORY_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.HURLY_CATEGORY_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].SEARCH_PAGE]: {
      routeName: PAGES.SEARCH_PAGE,
      pageType: 'search',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.SEARCH_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.SEARCH_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].COLLECTION_PAGE]: {
      routeName: PAGES.COLLECTION_PAGE,
      pageType: 'search',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.COLLECTION_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.COLLECTION_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].CAMPAIGN_PAGE]: {
      routeName: PAGES.CAMPAIGN_PAGE,
      pageType: 'campaign',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.CAMPAIGN_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.CAMPAIGN_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].BRANDS_PAGE]: {
      routeName: PAGES.BRANDS_PAGE,
      pageType: 'brands',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.BRANDS_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.BRANDS_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].DYNAMIC_PAGE]: {
      routeName: PAGES.DYNAMIC_PAGE,
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.DYNAMIC_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.DYNAMIC_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].DYNAMIC_VIEW_PAGE]: {
      routeName: PAGES.DYNAMIC_VIEW_PAGE,
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.DYNAMIC_VIEW_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.DYNAMIC_VIEW_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].TAG_PAGE]: {
      routeName: PAGES.TAG_PAGE,
      pageType: 'tag',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.TAG_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.TAG_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].STATIC_PAGE]: {
      routeName: PAGES.STATIC_PAGE,
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.STATIC_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.STATIC_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].STATIC_PAGE_PREVIEW]: {
      routeName: PAGES.STATIC_PAGE_PREVIEW,
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.STATIC_PAGE_PREVIEW}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.STATIC_PAGE_PREVIEW}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].PRODUCT_QNA_PAGE_WITH_PRODUCT_SKU]: {
      routeName: PAGES.PRODUCT_QNA_PAGE_WITH_PRODUCT_SKU,
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.PRODUCT_QNA_PAGE_WITH_PRODUCT_SKU}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.PRODUCT_QNA_PAGE_WITH_PRODUCT_SKU}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].PRODUCT_QNA_PAGE_WITH_PRODUCT_ID]: {
      routeName: PAGES.PRODUCT_QNA_PAGE_WITH_PRODUCT_ID,
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.PRODUCT_QNA_PAGE_WITH_PRODUCT_ID}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.PRODUCT_QNA_PAGE_WITH_PRODUCT_ID}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].PRODUCT_COMMENT_PAGE_WITH_PRODUCT_SKU]: {
      routeName: PAGES.PRODUCT_COMMENT_PAGE_WITH_PRODUCT_SKU,
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.PRODUCT_COMMENT_PAGE_WITH_PRODUCT_SKU}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.PRODUCT_COMMENT_PAGE_WITH_PRODUCT_SKU}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].PRODUCT_COMMENT_PAGE_WITH_PRODUCT_ID]: {
      routeName: PAGES.PRODUCT_COMMENT_PAGE_WITH_PRODUCT_ID,
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.PRODUCT_COMMENT_PAGE_WITH_PRODUCT_ID}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.PRODUCT_COMMENT_PAGE_WITH_PRODUCT_ID}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU]: {
      routeName: PAGES.PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU,
      pageType: 'product_detail',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].PRODUCT_DETAIL_PAGE_WITH_PRODUCT_ID]: {
      routeName: PAGES.PRODUCT_DETAIL_PAGE_WITH_PRODUCT_ID,
      pageType: 'product_detail',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.PRODUCT_DETAIL_PAGE_WITH_PRODUCT_ID}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.PRODUCT_DETAIL_PAGE_WITH_PRODUCT_ID}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].BRAND_PAGE]: {
      routeName: PAGES.BRAND_PAGE,
      pageType: 'brand',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.BRAND_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.BRAND_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].AUTHORS_PAGE]: {
      routeName: PAGES.AUTHORS_PAGE,
      pageType: 'authors',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.AUTHORS_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.AUTHORS_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].TEST_PAGE]: {
      routeName: PAGES.TEST_PAGE,
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.TEST_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.TEST_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.MOBILE].MERCHANTS_PAGE]: {
      routeName: PAGES.MERCHANTS_PAGE,
      pageType: 'merchants',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.MOBILE,
      onEnterActionName: `ENTER_${PAGES.MERCHANTS_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.MERCHANTS_PAGE}_ROUTE`,
    },
  },
  [PLATFORMS.DESKTOP]: {
    [ROUTE_PATHS[PLATFORMS.DESKTOP].HOME_PAGE]: {
      routeName: PAGES.HOME_PAGE,
      pageType: 'home',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.HOME_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.HOME_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].CAMPAIGN_PAGE]: {
      routeName: PAGES.CAMPAIGN_PAGE,
      pageType: 'campaign',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.CAMPAIGN_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.CAMPAIGN_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].BRANDS_PAGE]: {
      routeName: PAGES.BRANDS_PAGE,
      pageType: 'brands',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.BRANDS_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.BRANDS_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].DYNAMIC_PAGE]: {
      routeName: PAGES.DYNAMIC_PAGE,
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.DYNAMIC_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.DYNAMIC_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].DYNAMIC_VIEW_PAGE]: {
      routeName: PAGES.DYNAMIC_VIEW_PAGE,
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.DYNAMIC_VIEW_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.DYNAMIC_VIEW_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].STATIC_PAGE]: {
      routeName: PAGES.STATIC_PAGE,
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.STATIC_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.STATIC_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].STATIC_PAGE_PREVIEW]: {
      routeName: PAGES.STATIC_PAGE_PREVIEW,
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.STATIC_PAGE_PREVIEW}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.STATIC_PAGE_PREVIEW}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_QNA_PAGE_WITH_PRODUCT_SKU]: {
      routeName: PAGES.PRODUCT_QNA_PAGE_WITH_PRODUCT_SKU,
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.PRODUCT_QNA_PAGE_WITH_PRODUCT_SKU}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.PRODUCT_QNA_PAGE_WITH_PRODUCT_SKU}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_QNA_PAGE_WITH_PRODUCT_ID]: {
      routeName: PAGES.PRODUCT_QNA_PAGE_WITH_PRODUCT_ID,
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.PRODUCT_QNA_PAGE_WITH_PRODUCT_ID}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.PRODUCT_QNA_PAGE_WITH_PRODUCT_ID}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_COMMENT_PAGE_WITH_PRODUCT_SKU]: {
      routeName: PAGES.PRODUCT_COMMENT_PAGE_WITH_PRODUCT_SKU,
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.PRODUCT_COMMENT_PAGE_WITH_PRODUCT_SKU}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.PRODUCT_COMMENT_PAGE_WITH_PRODUCT_SKU}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_COMMENT_PAGE_WITH_PRODUCT_ID]: {
      routeName: PAGES.PRODUCT_COMMENT_PAGE_WITH_PRODUCT_ID,
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.PRODUCT_COMMENT_PAGE_WITH_PRODUCT_ID}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.PRODUCT_COMMENT_PAGE_WITH_PRODUCT_ID}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU]: {
      routeName: PAGES.PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU,
      pageType: 'product_detail',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_DETAIL_PAGE_WITH_PRODUCT_ID]: {
      routeName: PAGES.PRODUCT_DETAIL_PAGE_WITH_PRODUCT_ID,
      pageType: 'product_detail',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.PRODUCT_DETAIL_PAGE_WITH_PRODUCT_ID}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.PRODUCT_DETAIL_PAGE_WITH_PRODUCT_ID}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].AUTHORS_PAGE]: {
      routeName: PAGES.AUTHORS_PAGE,
      pageType: 'authors',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.AUTHORS_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.AUTHORS_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].TAG_PAGE]: {
      routeName: PAGES.TAG_PAGE,
      pageType: 'tag',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.TAG_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.TAG_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].MERCHANT_PAGE]: {
      routeName: PAGES.MERCHANT_PAGE,
      pageType: 'merchant',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.MERCHANT_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.MERCHANT_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].BRAND_PAGE]: {
      routeName: PAGES.BRAND_PAGE,
      pageType: 'brand',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.BRAND_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.BRAND_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].CATEGORY_PAGE]: {
      routeName: PAGES.CATEGORY_PAGE,
      pageType: 'category',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.CATEGORY_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.CATEGORY_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].BRAND_CATEGORY_PAGE]: {
      routeName: PAGES.BRAND_CATEGORY_PAGE,
      pageType: 'category',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.BRAND_CATEGORY_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.BRAND_CATEGORY_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].HURLY_CATEGORY_PAGE]: {
      routeName: PAGES.HURLY_CATEGORY_PAGE,
      pageType: 'category',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.HURLY_CATEGORY_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.HURLY_CATEGORY_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].SEARCH_PAGE]: {
      routeName: PAGES.SEARCH_PAGE,
      pageType: 'search',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.SEARCH_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.SEARCH_PAGE}_ROUTE`,
    },
    [ROUTE_PATHS[PLATFORMS.DESKTOP].MERCHANTS_PAGE]: {
      routeName: PAGES.MERCHANTS_PAGE,
      pageType: 'merchants',
      isPublic: true,
      exact: true,
      platform: PLATFORMS.DESKTOP,
      onEnterActionName: `ENTER_${PAGES.MERCHANTS_PAGE}_ROUTE`,
      onLeaveActionName: `LEAVE_${PAGES.MERCHANTS_PAGE}_ROUTE`,
    },
  },
}

const ROUTE_PATH_MOBILE_ARRAY = Object.values(ROUTE_PATHS[PLATFORMS.MOBILE])
const ROUTE_PATH_DESKTOP_ARRAY = Object.values(ROUTE_PATHS[PLATFORMS.DESKTOP])

const PAGE_ROUTE_PATHS_MOBILE = ROUTE_PATHS[PLATFORMS.MOBILE]
const PAGE_ROUTE_PATHS_DESKTOP = ROUTE_PATHS[PLATFORMS.DESKTOP]

const PAGE_ROUTE_PATH_MOBILE_ARRAY = Object.values(PAGE_ROUTE_PATHS_MOBILE)
const PAGE_ROUTE_PATH_DESKTOP_ARRAY = Object.values(PAGE_ROUTE_PATHS_DESKTOP)

const ROUTER_REDUX_ACTION_NAME = '@@router/LOCATION_CHANGE'
export {
  PAGES,
  PLATFORMS,
  ROUTE_PATHS,
  ROUTE_CONFIGS,
  ROUTE_PATH_MOBILE_ARRAY,
  ROUTE_PATH_DESKTOP_ARRAY,
  PAGE_ROUTE_PATHS_MOBILE,
  PAGE_ROUTE_PATHS_DESKTOP,
  PAGE_ROUTE_PATH_MOBILE_ARRAY,
  PAGE_ROUTE_PATH_DESKTOP_ARRAY,
  ROUTER_REDUX_ACTION_NAME,
}
